import React from "react";
import classnames from "classnames";

import { getColorCode } from "../utils/getColorCode";
import { EColors, EVariants } from "../types/enums";
import type { IOldButtonProps } from "../types";
import { OldButtonContent } from "./Content/OldButtonContent";

import styles from "./OldButton.module.scss";
import { Link } from "../../../link";

export const OldButton = ({
  children,
  className,
  color,
  variant,
  disabled,
  onClick,
  href,
  icon,
  secondIcon,
  loading,
  style,
  type = "button",
  subPrice,
  subPriceType,
  priceClass,
  verticalPadding = "15px",
  width = "180px",
  height = "50px",
  fontSize = "18px",
  targetBlank,
  analyticsId,
}: IOldButtonProps) => {
  const buttonClassNames = classnames(styles.button, className, {
    [styles.button__href]: href,
    [styles.button__text]: variant === EVariants.text,
    [styles.button__primary]: variant === EVariants.primary,
    [styles.button__hover]: variant === EVariants.colorOnHover,
    [styles.button__disabled]: disabled,
    [styles.button__lightgray]: color === EColors.lightgrey,
    [styles.button__orange]: color === EColors.orange,
    [styles.button__gray]: color === EColors.gray,
    [styles.button__green]: color === EColors.green,
    [styles.button__black]: color === EColors.black,
    [styles.button__purple]: color === EColors.purple,
    [styles.button__blue]: color === EColors.blue,
  });

  const buttonStyles = {
    ...style,
    "--width": width,
    "--height": height,
    "--fontSize": fontSize,
    "--verticalPadding": verticalPadding,
    "--main-color":
      variant === EVariants.colorOnHover ? getColorCode(color) : undefined,
  };

  const contentProps = {
    icon,
    secondIcon,
    loading,
    children,
    variant,
    priceClass,
    subPrice,
    subPriceType,
  };

  const target = targetBlank ? "_blank" : undefined;

  if (href) {
    return (
      <Link
        className={buttonClassNames}
        onClick={onClick}
        href={href}
        target={target}
        style={buttonStyles}
        data-analytics-id={analyticsId}
      >
        <OldButtonContent {...contentProps} />
      </Link>
    );
  }

  return (
    <button
      className={buttonClassNames}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      style={buttonStyles}
      data-analytics-id={analyticsId}
    >
      <OldButtonContent {...contentProps} />
    </button>
  );
};
